import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { CustomerService } from '../../../core/services/customer.service';
import { CreateContractService } from '../../../core/services/create-contract.service';
import { ProcedureService } from '../../../core/services/procedure.service';
import { EnterpriseService } from '../../../core/services/enterprise.service';
import { EnterpriseEntity } from '../../../core/class/enterpriseEntity';
import { ToastrService } from 'ngx-toastr';
import { UserEntity } from '../../../core/class/UserEntity';
import { EnumContractEnterpriseStatus, EnumContractUserRole } from '../../../core/constants/contract';
import { CommonService } from '../../../core/services/common.service';
import { Message } from '../../../core/class/message';
import { FormControl } from '@angular/forms';
import { UserService } from '../../../core/services/user.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'procedure-dialog',
  templateUrl: './procedure.component.html',
  styleUrls: ['./procedure.component.scss']

})
export class ProcedureComponent implements OnInit, OnDestroy {

  procedures: any[] = [];
  proceduresFilter: any[] = [];
  RECORD_PARTY_SIGN: EnterpriseEntity[] = [];
  RECORD_USER_PERFORM_SIGN: UserEntity[] = [];
  enumContractEnterpriseStatus = EnumContractEnterpriseStatus;
  showTableMembers = false;
  roleUser = EnumContractUserRole;
  enterpriseIdInDocument = '';
  loadingSearchType = false;
  searchCtrl: FormControl = new FormControl(null);
  valueSelect = null;
  indexUserSign = -1;
  // tslint:disable-next-line:variable-name
  private _onDestroy = new Subject<void>();
  @ViewChild('matSelect', { static: true }) matSelect;
  isShowUserSignTable = true;
  isShowUserApproveTable = false;
  isNotAttestedUser: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ProcedureComponent>,
    private customerService: CustomerService,
    public createContractService: CreateContractService,
    private procedureService: ProcedureService,
    private enterpriseService: EnterpriseService,
    private toast: ToastrService,
    private userService: UserService,
    private commonService: CommonService,
    private message: Message,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    dialogRef.disableClose = true;
    this.isNotAttestedUser = this.commonService.checkEnterpriseType();
  }
  ngOnDestroy(): void {
    this.createContractService.procedureId = null;
  }

  ngOnInit() {
    if (this.data.type) {
      this.getAllProcedure();
    }
    this.searchCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(v => {
      this.proceduresFilter = this.procedures.filter(item => {
        const s = this.commonService.extractUnicode(item.procedureName);
        return s.indexOf(this.commonService.extractUnicode(v)) > -1;
      });
    });
  }

  onNoClick() {
    this.createContractService.procedureId = null;
    this.dialogRef.close();
  }

  async checkCustomer(enterpriseOrUser: any) {
    const customer = await this.procedureService.checkCustomerUser({ customerId: enterpriseOrUser.customerId, userId: null }).toPromise();
    if (customer && customer.data) {
      return customer.data;
    }
    return false;
  }

  async checkUser(user: any) {
    const userDetail = await this.procedureService.checkCustomerUser({ customerId: null, userId: user.userId }).toPromise();
    if (userDetail && userDetail.data) {
      return userDetail.data;
    }
    return false;
  }

  async changeProcedure($event: any) {
    this.createContractService.procedureId = $event.value;
    this.getProcedure($event.value);
  }

  getAllProcedure() {
    this.procedureService.searchProcedureV2(
      {
        name: null,
        status: [1],
        type: [this.data.type],
        enterpriseId: localStorage.getItem('enterpriseId'),
        page: 0,
        pageSize: 999999999,
        id: null,
        internalFlowNotEdit: this.data.internalFlowNotEdit
      }
    ).subscribe(response => {
      if (!response || !response.data) {
        return;
      }
      this.procedures = response.data;
      this.proceduresFilter = response.data;
      // this.procedureService.searchProcedureV2(
      //   {
      //     name: null,
      //     status: [1],
      //     type: [this.data.type],
      //     userId: localStorage.getItem('userId'),
      //     page: 0,
      //     pageSize: 999999999,
      //     id: null,
      //     internalFlowNotEdit: this.data.internalFlowNotEdit
      //   }
      // ).subscribe(response => {
      //   if (!response || !response.data) {
      //     return;
      //   }
      //   this.procedures = this.procedures.concat(response.data);
      //   this.proceduresFilter = this.procedures;
      //   if (this.createContractService.procedureId) {
      //     this.getProcedure(this.createContractService.procedureId);
      //   }
      // }
      // );
      if (this.createContractService.procedureId) {
        this.getProcedure(this.createContractService.procedureId);
      }
    }
    );
  }

  getProcedure(procedureId: any) {
    this.RECORD_PARTY_SIGN = [];
    this.RECORD_USER_PERFORM_SIGN = [];
    const procedure = this.procedures.find(value => value.id === procedureId);
    this.procedureService.searchProcedureDetails({
      id: procedureId,
      name: procedure.procedureName,
      status: [1],
      type: [this.data.type],
      enterpriseId: localStorage.getItem('enterpriseId'),
      page: 0,
      pageSize: 999999999,
      checkMaxApprover: true,
    }).subscribe(async response => {
      const data = response.data;
      if (!data) {
        this.toast.error(response.message);
        this.createContractService.procedureId = null;
        return;
      }
      if (data.enterpriseSign && data.enterpriseSign.length) {
        let RECORD_PARTY_SIGN = [];
        data.enterpriseSign.forEach(el => {
          RECORD_PARTY_SIGN = [
            ...RECORD_PARTY_SIGN,
            {
              enterpriseId: el.enterpriseId,
              order: el.order != null ? el.order : 1,
              email: el.email,
              enterpriseName: '',
              phone: el.phone,
              customerType : el.customerType,
              status: this.enumContractEnterpriseStatus.NO_PROCESS,
              isCreatedSide: el.isCreatedSide,
              customerId: el.customerId,
              name: el.name,
              certificateNo: el.taxCode ? el.taxCode : el.certificateNo,
              useDataForTemplate: false,
              isSignNoLogin: el.isSignNoLogin,
              signConfig: el.signConfig ? ( JSON.parse(el.signConfig).showImage? JSON.parse(el.signConfig) : {showImage:false} ) : { resize: false, showImage: false }
            },
          ];
        });
        this.RECORD_PARTY_SIGN = RECORD_PARTY_SIGN.sort((a, b) => a.order - b.order);
      }

      if (data.userSign && data.userSign.length) {
        this.showTableMembers = true;
        let RECORD_USER_PERFORM_SIGN = [];
        data.userSign.sort((a, b) => {
          return b.role - a.role;
        });
        data.userSign.forEach(el => {
          RECORD_USER_PERFORM_SIGN = [
            ...RECORD_USER_PERFORM_SIGN,
            {
              order: el.order,
              userId: el.id,
              enterpriseSignId: localStorage.getItem('enterpriseId'),
              name: el.name,
              email: el.email,
              role: el.role + '',
              phone: el.phone,
              isSignDigitalCertificate: el.isSignDigitalCertificate ? el.isSignDigitalCertificate : false,
              isCreatedSide: true,
              signConfig: el.signConfig ? this.setDataSignConfig(JSON.parse(el.signConfig)) : { resize: false, showImage: true },
              userPosition: el.userPosition
            },
          ];
        });
        this.RECORD_USER_PERFORM_SIGN = RECORD_USER_PERFORM_SIGN;
        const checkUserSign = this.RECORD_USER_PERFORM_SIGN.filter(item => item.role === '1');
        if(checkUserSign.length > 0){
          this.indexUserSign = this.RECORD_USER_PERFORM_SIGN.indexOf(checkUserSign[0]);
        } else {
          this.indexUserSign = -1;
        }
        const existedList = this.RECORD_USER_PERFORM_SIGN.filter((e) => {
          return e.role != '1';
        });
        this.isShowUserApproveTable = (existedList != undefined && existedList.length > 0) ? true : false;
      } else {
        this.showTableMembers = false;
      }
    });
  }

  async confirm() {
    // const RECORD_USER_PERFORM_SIGN_APPROVE = this.RECORD_USER_PERFORM_SIGN.filter(user => user.role == '2');
    // if (!this.isBuyContract10Mb && this.isBuyContract1Mb && RECORD_USER_PERFORM_SIGN_APPROVE.length > this.configSizeApprove) {
    //   this.toast.error(this.message.getMessage('messages.maximum_number_of_internal_approvers').replace('{0}', String(Math.floor(this.configSizeApprove))));
    //   return;
    // }
    if(this.checkOrderUnique()){
      const message = this.message.getMessage('validation.error_order');
      this.toast.error(message);
      return;
    }
    
    this.createContractService.signPositions.next([]);
    const procedure = this.procedures.find(value => value.id === this.createContractService.procedureId);
    const procedureDetail = await this.procedureService.searchProcedureDetails({
      id: this.createContractService.procedureId,
      name: procedure.procedureName,
      status: [1],
      type: [this.data.type],
      enterpriseId: localStorage.getItem('enterpriseId'),
      page: 0,
      pageSize: 999999999,
    }).toPromise();
    if (!procedureDetail.data) {
      const message = this.message.getMessage('messages.procedure_not_available').replace('{0}', procedure.procedureName);
      this.toast.error(message);
      this.createContractService.procedureId = null;
      return;
    }
    const recordPartySignNotExists = [];
    for (const el of this.RECORD_PARTY_SIGN) {
      if (!el.isCreatedSide && !await this.checkCustomer(el)) {
        recordPartySignNotExists.push(el);
      }
    }
    const recordUserPerformSignNotExists = [];
    for (const el of this.RECORD_USER_PERFORM_SIGN) {
      const isExists = await this.checkUser(el);
      if (!isExists) {
        recordUserPerformSignNotExists.push(el);
      }
    }
    if (recordPartySignNotExists && recordUserPerformSignNotExists && recordPartySignNotExists.length && recordUserPerformSignNotExists.length) {
      const customers = recordPartySignNotExists.map(el => {
        return el.name;
      }).join(', ');
      const users = recordUserPerformSignNotExists.map(el => {
        return el.name;
      }).join((', '));
      const message = this.message.getMessage('messages.choose_procedure_error_customer_user').replace('{0}', customers).replace('{1}', users);
      this.toast.error(message);
      return;
    } else if (recordPartySignNotExists && recordPartySignNotExists.length) {
      const customers = recordPartySignNotExists.map(el => {
        return el.name;
      }).join(', ');
      const message = this.message.getMessage('messages.choose_procedure_error_customer').replace('{0}', customers);
      this.toast.error(message);
      return;
    } else if (recordUserPerformSignNotExists && recordUserPerformSignNotExists.length) {
      const users = recordUserPerformSignNotExists.map(el => {
        return el.name;
      }).join(', ');
      const message = this.message.getMessage('messages.choose_procedure_error_user').replace('{0}', users);
      this.toast.error(message);
      return;
    }
    if (this.data.type === 1) {
      this.createContractService.recordsPartySign.next(
        this.RECORD_PARTY_SIGN
      );
    }

    this.createContractService.recordsUserPerformSign.next(
      this.RECORD_USER_PERFORM_SIGN
    );

    this.createContractService.procedureId = null;
    this.dialogRef.close(true);
  }

  setColspan(maximumSpan: number): number {
    if (this.valueSelect !== 0) maximumSpan -= 1;
    if (this.isNotAttestedUser && this.data.type == 1) maximumSpan -= 1;

    return maximumSpan;
  }

  checkOrderUnique(): boolean {
    const orders = this.RECORD_USER_PERFORM_SIGN
      .filter((item: any) => item.role == 2 || item.role == '2')
      .map((item: any) => item.order)
      .filter((order: any) => order !== null && order !== undefined);
  
    const countMap = new Map<number, number>();
    let checkCount = false;
  
    for (const order of orders) {
      countMap.set(order, (countMap.get(order) || 0) + 1);
      if (countMap.get(order)! > 1) {
        checkCount = true;
      }
    }
  
    return checkCount;
  }

  setDataSignConfig(signConfig: any) {
    let newDataSignConfig = { ...signConfig };
    if(newDataSignConfig.resize === null || newDataSignConfig.resize === undefined) {
      newDataSignConfig = { ...newDataSignConfig, resize: false };
    }
    if(newDataSignConfig.showImage === null || newDataSignConfig.showImage === undefined) {
      newDataSignConfig = { ...newDataSignConfig, showImage: true };
    }
    return newDataSignConfig;
  }
}
